
import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import S from '@/store'
import config from '@/config'
import observableWindow from '@/observable/window'

import stylus from '@/stylesheets/stylus'

import {
    UiCard,
    UiLoadingOverlay,
    UiFormattedText,
    UiToastPortalTarget,
    UiModalPortalTarget,
} from '@hubsolv/hubsolv-ui'

import EventBus from '@/event-bus'

@Component({
    components: {
        UiCard,
        UiFormattedText,
        UiLoadingOverlay,
        UiModalPortalTarget,
        UiToastPortalTarget,
    },
})
export default class App extends Vue {

    ////////////////////////////////////////////////////////////////
    // data
    ////////////////////////////////////////////////////////////////

    loading: boolean = true
    showErrorModal: boolean = false
    errorModalMessage: string | null = 'An unexpected error has occurred. Please try again or reload the page.'

    ////////////////////////////////////////////////////////////////
    // Vuex bindings
    ////////////////////////////////////////////////////////////////
    
    @S.Auth.Getter loggedIn!: any
    @S.Auth.Getter initialised!: any

    ////////////////////////////////////////////////////////////////
    // watchers
    ////////////////////////////////////////////////////////////////

    @Watch('loggedIn')
    onChangeLoggedIn () {
        this.tryToFinishLoading()
    }

    @Watch('initialised')
    onChangeInitialised () {
        this.tryToFinishLoading()
    }

    @Watch('$route')
    onChangeRoute () {
        this.tryToFinishLoading()
    }

    ////////////////////////////////////////////////////////////////
    // lifecycle
    ////////////////////////////////////////////////////////////////

    created () {
        this.tryToFinishLoading()
    }

    mounted () {
        EventBus.$on('app-error', (message: string) => {
            this.showErrorModal = true
            this.errorModalMessage = message
        })
    }

    ////////////////////////////////////////////////////////////////
    // methods
    ////////////////////////////////////////////////////////////////

    tryToFinishLoading () {
        if (!this.loading) return // Loading already finished.

        if (
            (this.$route.meta && this.$route.meta.requiresInitialisation === false) ||
            ((!this.$route.meta || this.$route.meta.requiresInitialisation !== false) && this.initialised)
        ) {
            this.loading = false
        }
    }

    ////////////////////////////////////////////////////////////////
    // event handlers
    ////////////////////////////////////////////////////////////////

    onClickModalAction () {
        // this.hideModal()
    }

    onClickClose () {
        // this.hideModal()
    }

}

